import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerBodyTypeAll: [],
  insurerBodyType: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerBodyTypeSlice = createSlice({
  name: "insurerBodyType",
  initialState,
  reducers: {
    setInsurerBodyTypeAll: (state, action) => {
      state.insurerBodyTypeAll = action.payload;
    },
    setInsurerBodyType: (state, action) => {
      state.insurerBodyType = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerBodyTypeAll,
  setInsurerBodyType,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerBodyTypeSlice.actions;

export default insurerBodyTypeSlice.reducer;
